import { useApiCrossBrandMallHomeDetail } from '@hooks-api/fortune/use-api-cross-brand-mall-home-detail'
import { Box } from '@pets-ui/Box/Box'
import { Collapse } from '@pets-ui/Collapse/Collapse'
import { Container } from '@pets-ui/Container/Container'
import { HStack } from '@pets-ui/HStack/HStack'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { zIndex } from '@pets-ui/tokens/zIndex.stylex'
import { useMemo } from 'react'
import { type BrandCategory, type BrandInfo, HEADER_HEIGHT } from '../../constants'
import { STM_COUNTRY_CONFIG } from '../../constants/constants'
import { useStmBrandStore } from '../../hooks'
import { useCountryCode } from '../../hooks/use-country-code'
import { BrandCard } from './BrandCard'

interface BrandNavDropdownProps {
  activeCategory: BrandCategory | null
  onSelectBrand?: (brand: BrandInfo) => void
}

export const BrandNavDropdown = (props: BrandNavDropdownProps) => {
  const { activeCategory, onSelectBrand } = props
  const { brands: allBrands } = useStmBrandStore()
  const countryCode = useCountryCode()
  const mallCode = STM_COUNTRY_CONFIG[countryCode]?.mallCode ?? null
  const { destructuredData: homeDetail } = useApiCrossBrandMallHomeDetail({ mall_code: mallCode })

  const brands = useMemo(() =>
    allBrands.filter(brand => brand.category === activeCategory),
  [allBrands, activeCategory])

  return (
    <Box position="fixed" top={HEADER_HEIGHT} left={0} right={0} zIndex={zIndex.appBar}>
      <Collapse in={activeCategory !== null}>
        <Box backgroundColor={colors.blueGrey200} py={5}>
          <Container>
            <HStack gap={22}>
              {brands.map(brand => {
                const customLogoUrl = homeDetail?.campaigns.find(campaign => campaign.code === brand.campaignCode)?.logos[0]?.url
                return (
                  <BrandCard
                    key={brand.campaignCode}
                    brand={brand}
                    customLogoUrl={customLogoUrl}
                    onClick={onSelectBrand}
                  />
                )
              })}
            </HStack>
          </Container>
        </Box>
      </Collapse>
    </Box>
  )
}
